import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";
import { AuthContext } from "./AuthContext";
import { UserContext } from "./UserContext";
import { notificationApiUrl } from "../utils/GetUrl";
import isGuestUser from '../utils/guestUser';

const NotificationContext = createContext();
export const useNotifications = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const { userData, token, fetchGeneralNotifications } = useContext(AuthContext);
  const { usersList } = useContext(UserContext);
  const user = userData?.[0];

  const fetchNotifications = async () => {
    if (!user || !token) return;
    const userEmpID = user?.EM_ID;
    try {
      const response = await fetch(
        `${notificationApiUrl}/GetNotificationMessage?FirstCount=1&LastCount=10&Userid=${userEmpID}&sendto=${userEmpID}`,
        { method: "GET", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      if (!response.ok) return;
      const data = await response.json();
      setNotifications(data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    if (user && token) {
      fetchNotifications();
    }
  }, [user, token]);

  const postNotification = async (message) => {
    if (isGuestUser(userData?.[0]?.DRM_ID)) return;
    try {
      const response = await fetch(`${notificationApiUrl}/PostNotification`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ message, createdby: user?.EM_ID, sendTo: [user?.EM_ID?.toString()] }),
      });
      if (response.ok) {
        await fetchNotifications();
        await fetchGeneralNotifications();
      }
    } catch (error) {
      console.error("Error posting notification:", error);
    }
  };

  return (
    <NotificationContext.Provider
      value={{ notifications, setNotifications, fetchNotifications, postNotification }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
